import { render } from "./editarSolicitudes.vue?vue&type=template&id=5d17aa1d"
import script from "./editarSolicitudes.vue?vue&type=script&lang=js"
export * from "./editarSolicitudes.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__